import React from 'react'
import './App.css'
import styled, { createGlobalStyle } from 'styled-components'
import { QueryClient, QueryClientProvider } from 'react-query'
import { ReactQueryDevtools } from 'react-query/devtools'
import { persistQueryClient } from 'react-query/persistQueryClient-experimental'
import { createWebStoragePersistor } from 'react-query/createWebStoragePersistor-experimental'

import { library } from '@fortawesome/fontawesome-svg-core'
import {
  faArrowsAlt, faEdit, faExpand, faExpandArrowsAlt, faTimesCircle, faTrashAlt, faAngleDown,
  faAlignLeft, faAlignCenter, faAlignRight, faPlusCircle, faSortAmountUpAlt, faSortAmountDownAlt
} from '@fortawesome/free-solid-svg-icons'
import Editor from './components/Editor'
import { DesignProvider } from './store'

library.add(
  faExpandArrowsAlt, faArrowsAlt, faEdit, faExpand, faTimesCircle, faTrashAlt, faAngleDown,
  faAlignLeft, faAlignCenter, faAlignRight, faPlusCircle, faSortAmountUpAlt, faSortAmountDownAlt
)

const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        refetchOnWindowFocus: false,
        cacheTime: 1000 * 60 * 60 * 12, // 12 hours
      },
    },
  }
)
const localStoragePersistor = createWebStoragePersistor({ storage: window.localStorage })

const CACHE_BUSTER = new Date().toDateString()
const REACTQUERYDEVTOOLS_ACTIVE = false

persistQueryClient({
  queryClient,
  persistor: localStoragePersistor,
  buster: CACHE_BUSTER
})

function App (props) {
  return (
    <Page>
      <GlobalStyle />
      <React.StrictMode>
        <QueryClientProvider client={queryClient}>
          {REACTQUERYDEVTOOLS_ACTIVE && <ReactQueryDevtools position="bottom-right" />}
          <DesignProvider>
            <Editor {...props} />
          </DesignProvider>
        </QueryClientProvider>
      </React.StrictMode>
    </Page>
  )
}

App.whyDidYouRender = true

export default App

const GlobalStyle = createGlobalStyle`
  @page {
    size: landscape;
    margin: 0;
`

const Page = styled.div`
  width: 100%;
  height: 100%;  
`